import { Link } from 'i18n'
import { Row, Col, Container } from 'react-bootstrap'
import { X, Facebook, Instagram } from 'assets/icons/components'

const Footer = (props) => {
  const { t } = props


  return (
    <Container>
      <div className='container-footer'>
        <Row>
          <Col lg={1} xs={1} md={1}></Col>
          <Col lg={10} xs={10} md={10}>
            <div className='container-footer__social'>
              <a
                href='https://x.com/flirtbees'
                target='_blank'
                className='sub-social'
                aria-label='X'
                rel="noopener">
                <X className='sub-social__icon' />
              </a>
              <a
                href='https://fb.com/flirtbees'
                target='_blank'
                className='sub-social'
                aria-label='Facebook'
                rel="noopener">
                <Facebook className='sub-social__icon' />
              </a>
              <a
                href='https://instagram.com/flirtbees'
                target='_blank'
                rel="noopener"
                aria-label='Instagram'
                className='sub-social'>
                <Instagram className='sub-social__icon' />
              </a>
            </div>
          </Col>
          <Col lg={1} xs={1} md={1}></Col>
        </Row>
        <Row>
          <Col lg={12} xs={12} md={12}>
            <div className='container-footer__bottom'>
              <div className='container-footer__bottom-menu'>
                <div >
                  <a
                    href='/user-agreement'
                    target='_blank'
                    className='sub-menu'>
                    {t('TERMS')}
                  </a>
                </div>
                <div >
                  <a
                    target='_blank'
                    href='/privacy-policy'
                    className='sub-menu'>
                    {t('PRIVACY')}
                  </a>
                </div>
                <div >
                  <a
                    target='_blank'
                    href='/2257-compliance'
                    className='sub-menu' >
                    {t('2257 COMPLIANCE')}
                  </a>
                </div>
                <div >
                  <a
                    target='_blank'
                    href='https://affiliates.flirtbees.com'
                    className='sub-menu' >
                    {t('AFFILIATE PROGRAM')}
                  </a>
                </div>
              </div>
              <div className='container-footer__bottom-copywriter'>
                <div dangerouslySetInnerHTML={{ __html: "<!--googleoff: index-->" }} />
                <amp-img layout="responsive" src="https://assets.flirtbees.com/assets/company-address-ae.png" style={{ width: '500px', 'max-width': '100%', margin: '0 auto' }} alt="Company address" 
                  width="500" height="16" ></amp-img>
                <div style={{ marginBottom: '-5px', maxWidth: '90%', margin: '0 auto' }}>
                  <span style={{ fontSize: '14px' }}>VAT:</span> <img src="/images/vat.png" style={{ height: '24px' }}/>
                  <span style={{ fontSize: '14px', paddingLeft: '5px' }}>{t('Phone')}:</span> <img src="/images/phone.png" style={{ height: '15px' }}/>
                  <span style={{ fontSize: '14px', paddingLeft: '5px', whiteSpace: 'nowrap' }}>{t('Company number')}:</span> <img src="/images/address.png" style={{ height: '22px' }}/>
                </div>
                <p >© 2020-2026 Flirtbees™. {t('All Rights Reserved')}. Email: <a style={{ color: '#ec0043' }} href='mailto:support@flirtbees.com'>support@flirtbees.com</a></p>
                <div>
                  <span style={{ verticalAlign: 'super' }}>{t('We accept')}:</span> <amp-img  src="https://assets.flirtbees.com/assets/visa.svg" alt="Visa" height="23" width="36"></amp-img> 
                  <amp-img  src="https://assets.flirtbees.com/assets/master.svg" alt="Master card" height="23" width="32" style={{ marginLeft: '5px' }}></amp-img>
                  {/* <amp-img src="https://assets.flirtbees.com/assets/giropay.jpg" style={{ marginLeft: '5px' }} alt="Giropay" height="23" width="23"></amp-img>  */}
                  {/* <amp-img src="https://assets.flirtbees.com/assets/bitcoin.jpg" style={{ height: '23px', marginLeft: '5px' }} alt="Bitcoin" height="23" width="23"></amp-img>
                  <amp-img src="https://assets.flirtbees.com/assets/dinersclub.jpg" style={{ height: '23px', marginLeft: '5px' }} alt="Dinersclub" height="23" width="23"></amp-img>
                  <amp-img src="https://assets.flirtbees.com/assets/axp.svg" style={{ height: '23px', marginLeft: '5px' }} alt="Axp" height="23" width="23"></amp-img>
                  <amp-img src="https://assets.flirtbees.com/assets/ideal.svg" style={{ height: '23px', marginLeft: '5px' }} alt="iDeal" height="23" width="36"></amp-img>
                  <amp-img src="https://assets.flirtbees.com/assets/eps.png" style={{ height: '23px', marginLeft: '5px' }} alt="Eps" height="23" width="36"></amp-img>
                  <amp-img src="https://assets.flirtbees.com/assets/sofort.png" style={{ height: '23px', marginLeft: '5px' }} alt="Sofort" height="23" width="60"></amp-img> */}
                </div>
                <div dangerouslySetInnerHTML={{ __html: "<!--googleoff: index-->" }} />
              </div>

            </div>
          </Col>
        </Row>
      </div>
      <script async src="https://cdn.ampproject.org/v0.js"></script>
    </Container>
  )
}
export default Footer
